export * from "../../constants";

/**
 * Enum representing field names used in the Commercetools platform.
 * This enum provides specific mappings for customer-related fields from an external LMS system.
 *
 * Members of this enum can be used as keys to interact with Commercetools API or other systems that
 * require their corresponding values.
 *
 * @see Taken from: https://github.com/edx/commerce-coordinator/blob/007ac6f732678bebe82a2a85bf219b69f5d5570b/commerce_coordinator/apps/commercetools/catalog_info/constants.py
 */
export enum CommercetoolsFieldName {
  CustomerLmsUserId = "edx-lms_user_id",
  CustomerLmsUserName = "edx-lms_user_name",
}

/**
 * Custom object and type names used in CommerceTools
 */
export const CustomObjectNames = {
  OrderNumberTracker: {
    container: "orderNumbers",
    key: "orderNumber",
    customField: "cart-orderNumber",
  },
  LineItemBundle: {
    typeKey: "lineItemsBundleCustomType",
  },
} as const;

export const DefaultCookieSettings: {
  secure: boolean;
  sameSite: "lax" | "strict" | "none" | undefined;
} = {
  secure: true,
  sameSite: "lax",
};

export enum CurrencyCode {
  UsDollar = "USD",
}

export enum CheckoutQPs {
  Courses = "course_run_key",
  Programs = "bundle",
}
